import { useHive } from "@/store/useHive";

/**
 * The sample-data call-to-action for empty surfaces:
 *  - no samples seeded yet    → "Explore with sample data" (seeds + shows)
 *  - seeded but hidden        → "Show sample data" (flips visibility back on)
 *  - seeded and visible       → null (lists have rows; empty states don't render)
 *
 * Centralised so a user who hides samples is never stranded — every surface
 * that offered the demo also offers the way back.
 */
export function useSampleDataCta(): { label: string; run: () => void } | null {
  const present = useHive((s) => !!s.sampleData?.present);
  const visible = useHive((s) => !!s.sampleData?.visible);
  const seedSampleData = useHive((s) => s.seedSampleData);
  const setSampleVisibility = useHive((s) => s.setSampleVisibility);

  if (!present) return { label: "Explore with sample data", run: () => void seedSampleData() };
  if (!visible) return { label: "Show sample data", run: () => void setSampleVisibility(true) };
  return null;
}
